import React from 'react';
import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
} from 'shared/styles/commonStyles';
import { useDispatch } from 'react-redux';

const MasterControlBySwitchTitle = ({
  isExpand,
  expandFC,
  swtName,
  index,
  modifyLength,
  modifyBorderRadius,
  isLocation,
  isSpecificLocation,
}) => {
  const btName = isExpand ? 'close' : 'expand';

  const dispatch = useDispatch();
  return (
    <MCTitleWrapper
      isExpanded={isExpand}
      modifyBorderRadius={modifyBorderRadius}
      modifyLength={modifyLength}
    >
      <MCTitle isExpanded={isExpand}>
        master control -{' '}
        {isLocation
          ? `location ${swtName}`
          : isSpecificLocation
          ? `specific location ${swtName}`
          : swtName}
      </MCTitle>
      <ButtonWrapper
        isExpanded={isExpand}
        onClick={() =>
          dispatch(
            expandFC({
              swtName,
              locationIdx: index,
              status: !isExpand,
            })
          )
        }
      >
        <ButtonHole isExpanded={isExpand}>
          <ButtonTop isExpanded={isExpand}>{btName}</ButtonTop>
        </ButtonHole>
      </ButtonWrapper>
    </MCTitleWrapper>
  );
};

export default MasterControlBySwitchTitle;

const MCTitleWrapper = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween}
  padding: 0 4px 12px;
  border-bottom: 1px solid var(--switch-border);

  ${({ modifyLength, modifyBorderRadius }) =>
    modifyBorderRadius &&
    css`
      width: ${modifyLength};
    `}
`;

const MCTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: capitalize;
  color: var(--switch-text-primary);
`;

const ButtonWrapper = styled.button`
  height: 28px;
  padding: 0 18px;
  border-radius: 9999px;
  background: var(--switch-button-bg);
  border: 1px solid var(--switch-border);
  ${flexBoxCenter};
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: var(--switch-button-hover-bg);
    border-color: var(--switch-blue-border);
  }
`;

const ButtonHole = styled.div`
  ${flexBoxCenter};
`;

const ButtonTop = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--switch-text-secondary);
  ${flexBoxCenter};
`;
